import { Component, OnInit } from '@angular/core';
import { SiteConfigService } from '@services';
import {
  FooterButtonConfig,
  FooterConfig,
  FooterLinkConfig,
} from '../../../core/interfaces/site-config.interface';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  footerConfig: FooterConfig | undefined;
  footerLinks: FooterLinkConfig[] = [];
  footerButtons: FooterButtonConfig[] = [];

  constructor(private siteConfigService: SiteConfigService) {}

  ngOnInit(): void {
    this.siteConfigService.getConfig().subscribe((config) => {
      if (config?.footer) {
        this.footerConfig = config.footer;
        this.footerLinks = config.footer.links?.filter((link) => link.enabled !== false) || [];
        this.footerButtons = config.footer.buttons?.filter((button) => button.enabled) || [];
      }
    });
  }

  get footerLogo() {
    return this.footerConfig?.logo;
  }

  isInternalLink(link: FooterLinkConfig | FooterButtonConfig): boolean {
    return link.type === 'internal';
  }

  getLinkPath(href: string): string {
    // Extract path before the hash
    return href.split('#')[0] || '/';
  }

  getLinkFragment(href: string): string | undefined {
    // Extract fragment after the hash
    const parts = href.split('#');
    return parts.length > 1 ? parts[1] : undefined;
  }
}
